import { useGetPortalConfigQuery } from 'src/services/api';

/**
 * Check if default channel should be company. Returns true when companyDisabled is false
 * and default channel type is set to company
 * @returns true/false if portal is configured to use company channel
 */
export const useCompanyChannel = () => {
  const { data: config } = useGetPortalConfigQuery();
  const useDefaultCompanyChannel =
    !config?.structFields?.disableCompanies &&
    config?.structFields?.defaultChannelType === 'company';

  return useDefaultCompanyChannel;
};
